import { writeCustomTypeModel } from "./writeCustomTypeModel.js";
const renameCustomType = async (args) => {
  await writeCustomTypeModel(args);
};
export {
  renameCustomType
};
//# sourceMappingURL=renameCustomType.js.map
